<template>
  <div v-loading="pageLoading">
    <div class="head">
      <div v-if="!$store.getters.isAllCountry" class="tip-box">
        <svg-icon class-name="icon-function" icon-class="icon-font-warning" />
        <span class="tips">{{ $t('tips.add_up_six_account') }}</span>
      </div>
      <el-button type="info" size="small" icon="el-icon-plus" class="add-btn" @click="onClickAddBtn">{{ $t('data.add_new_bank_account') }}</el-button>
    </div>
    <div class="bank-box">
      <!--        银行账户列表-->
      <div v-for="(item, index) in bankAccountList" :key="index" class="bank-item">
        <div class="bank-head">
          <div class="left">
            <span class="bank-account">
              <svg-icon icon-class="money-plain" style="position: relative; top:-1px; font-size: 12px;" />
              {{ showCurrency(item) }}
            </span>
            <span
              :class="{
                [aduitStatus[item.audit_status]]: true,
                status: true
              }"
            >
              {{ item.audit_status === 1 ? $t('system.reviewing') : ( item.audit_status === 2 ? $t('system.activated'): $t('system.reject')) }}
            </span>
          </div>
          <svg-icon class-name="icon-function" icon-class="operation-delete" @click="clickDelete(item)" />
        </div>
        <div class="content">
          <p class="content-item">
            <span class="name">{{ $t('merchant.account_bank') }}:</span>
            <span class="value">{{ item.settlement_bank }}</span>
          </p>
          <p class="content-item">
            <span class="name">{{ $t('merchant.account_name') }}:</span>
            <span class="value">{{ item.settlement_bank_account_name }}</span>
          </p>
          <p class="content-item">
            <span class="name">{{ $t('merchant.account_num') }}:</span>
            <span class="value">{{ item.settlement_bank_account_num }}</span>
          </p>
        </div>
      </div>
      <!-- <div class="bank-item">
          <div class="bank-head">
            <div class="left">
              <span class="bank-account">Account No. 1</span>
              <span class="pending">Reviewing</span>
            </div>
            <svg-icon class-name="icon-function" icon-class="operation-delete"/>
          </div>
          <div class="content">
            <p class="content-item">
              <span class="name">Bank:</span>
              <span class="value">ABP</span>
            </p>
            <p class="content-item">
              <span class="name">Bank Account Number:</span>
              <span class="value">003-10-00014-9</span>
            </p>
          </div>
        </div>
        <div class="bank-item">
          <div class="bank-head">
            <div class="left">
              <span class="bank-account">Account No. 1</span>
              <span class="pending">Reviewing</span>
            </div>
            <svg-icon class-name="icon-function" icon-class="operation-delete"/>
          </div>
          <div class="content">
            <p class="content-item">
              <span class="name">Bank:</span>
              <span class="value">ABP</span>
            </p>
            <p class="content-item">
              <span class="name">Bank Account Number:</span>
              <span class="value">003-10-00014-9</span>
            </p>
          </div>
        </div>
        <div class="bank-item">
          <div class="bank-head">
            <div class="left">
              <span class="bank-account">Account No. 1</span>
              <span class="pending">Reviewing</span>
            </div>
            <svg-icon class-name="icon-function" icon-class="operation-delete"/>
          </div>
          <div class="content">
            <p class="content-item">
              <span class="name">Bank:</span>
              <span class="value">ABP</span>
            </p>
            <p class="content-item">
              <span class="name">Bank Account Number:</span>
              <span class="value">003-10-00014-9</span>
            </p>
          </div>
        </div> -->
    </div>
    <!--        添加银行账户弹窗-->
    <MultiMchAddBankAccountModal v-if="$store.getters.isAllCountry" ref="addBankAccountModal" @submit="getBankAccountList" />
    <AddBankAccountModal v-else ref="addBankAccountModal" @submit="getBankAccountList" />
    <!--        删除银行账户-->
    <DeleteBankAccountModal ref="deleteBankAccountModal" @submit="getBankAccountList" />
  </div>
</template>

<script>

import { GetMoreBankList, GetMultiMchMoreBankList } from '@/api/data/data'
import { generateTitle } from '@/utils/i18n'
export default {
  name: 'Bank-Account-List', // 银行账户列表页
  components: {
    AddBankAccountModal: () => import('./Modal/AddBankAccountModal.vue'),
    MultiMchAddBankAccountModal: () => import('./Modal/MultiMchAddBankAccountModal.vue'),
    DeleteBankAccountModal: () => import('./Modal/DeleteBankAccountModal.vue')
  },
  data() {
    this.SETTLEMENT_TYPE = {
      local: 1,
      usd: 2
    }
    this.aduitStatus = {
      1: 'pending',
      2: 'success',
      3: 'warning'
    }
    return {
      bankAccountList: [],
      pageLoading: false
    }
  },
  computed: {
    showCurrency() {
      return function(item) {
        if (item.settlement_type === this.SETTLEMENT_TYPE['usd']) {
          return 'USD'
        }
        if (this.$store.getters.isAllCountry) {
          const selectedCountry = this.$store.state.page.countryArr.find(country => country.code === item.settlement_country)
          return selectedCountry ? selectedCountry.currency : ''
        }
        return this.$store.getters.currency
      }
    }
  },
  created() {
    this.getBankAccountList()
  },
  methods: {
    generateTitle,
    onClickAddBtn() {
      if (this.bankAccountList.length === 6 && !this.$store.getters.isAllCountry) {
        return this.$message.warning('You can only add up to six accounts.')
      }
      this.$refs.addBankAccountModal.changeModalStatus(true)
    },
    clickDelete(item) {
      if (this.bankAccountList.length <= 1) return this.$message.warning(this.$t('tips.delete_last_bank'))
      if (item.auto_status === 1) return this.$message.warning(this.$t('tips.delete_auto_withdrawal_bank'))
      this.$refs.deleteBankAccountModal.showModal(item)
    },
    getBankAccountList() {
      this.pageLoading = true
      const fetchBankAccountList = this.$store.getters.isAllCountry
        ? GetMultiMchMoreBankList
        : GetMoreBankList
      fetchBankAccountList().then(res => {
        this.bankAccountList = res.data || []
      }).finally(() => {
        this.pageLoading = false
      })
    }
  }
}
</script>

  <style scoped lang="scss">
  .add-btn {
    // width: 280px;
    // height: 56px;
    // font-weight: 600;
    // font-size: 16px;
  }
    .head{
      margin: 20px 0 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tip-box {
        display: flex;
        align-items: center;
      }
    }
    .bank-box {
      display: grid;
      // justify-content: space-between;
      align-items: center;
      gap: 20px;
      grid-template-columns: repeat(auto-fill, 410px);
      font-size: 14px;
      .bank-item {
        // height: 105px;
        background: #FFFFFF;
        border: 1px solid #D3D7DF;
        border-radius: 8px;
        padding: 14px;
        .bank-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            display: flex;
            align-items: center;
            .bank-account {
              color: #1D3A71;
              font-size: 14px;
              font-weight: bold;
              margin-right: 16px;
            }
            .status {
              font-size: 12px;
              width: 82px;
              height: 23px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 12px;
            }
            .pending {
              background: #FDE68A;
              color: #B45309;
            }
            .success {
              color: #047857;
              background: #A7F3D0;
            }
            .warning{
              background-color: #FFE1C4;
              color: #EE7700;
            }
          }
        }
        .content {
          &-item {
            line-height: 1;
            overflow: hidden; /* 隐藏溢出部分 */
            text-overflow: ellipsis; /* 在文本末尾添加省略号 */
            .name {
              white-space: nowrap; /* 禁止文本换行 */
              margin-right: 12px;
            }
            .value {
              color: #4B5567;
              font-weight: bold;
              white-space: nowrap; /* 禁止文本换行 */
            }
          }
        }
      }
    }
  </style>
